export function debounce(fn, waitMs = 0) {
  let timerId = null

  function debounced(...args) {
    if (timerId) {
      clearTimeout(timerId)
    }

    timerId = setTimeout(() => {
      timerId = null
      fn(...args)
    }, waitMs)
  }

  debounced.cancel = () => {
    if (timerId) {
      clearTimeout(timerId)
      timerId = null
    }
  }

  return debounced
}

